OE.addPlugin('Taxonomyfilter', (function(){

    var Plugin = {},
        Options = {
        },
        querySelector = '[class*="filter__show-all "], [class$="filter__show-all"]';

    Plugin.init = function()
    {
        /*
        var lists = OE.$doc.querySelectorAll(querySelector),
            list_count = lists.length;

        for(var i = 0; i < list_count; i++ )
        {
            var container = getContainerFor(lists[i]);
            if(container.querySelector('.is--hidden:not(.is--active)'))
            {
                container.classList.add('has--hidden-items');
            }
        }
        */

        OE.Utils.delegateEvent(
            CLICK,
            docEventListener,
            querySelector
        );
    };

    var docEventListener = function(e)
    {
        var container = getContainerFor(e.target);
        if(container)
        {
            container.classList.remove('has--hidden-items');
        }
    };

    var getContainerFor = function(element)
    {
        while (element.parentElement && !element.classList.contains('taxonomy-filter'))
        {
            element = element.parentElement;
        }

        return element;
    };

    return Plugin;
})());
